import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 0;
  gap: 16px;
`;

export const Spinner = styled.span<{ $size: number; $color: string }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border: 3px solid hsla(0, 0%, 0%, 0.08);
  border-top-color: ${({ $color }) => $color};
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const Message = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors['neutral-60']};
`;
